import Swup from 'swup';
import SwupScrollPlugin from '@swup/scroll-plugin';
import SwupPreloadPlugin from '@swup/preload-plugin';

export const filtersAndPages = ({ selector, resetSelects = false }) => {
  const container = document.querySelector(selector);

  if (!container) {
    return;
  }

  let inner = container.querySelector(`${selector}__inner`);

  const swup = new Swup({
    plugins: [new SwupScrollPlugin(), new SwupPreloadPlugin()],
    animationSelector: `${selector}__inner`,
    containers: [`${selector}__inner`],
    linkSelector: `${selector} .pagination a`,
    ignoreVisit: (url) => {
      const path = url.split('?')[0];

      if (path !== window.location.pathname) {
        return true;
      }
    },
  });

  // prevent scroll to top
  swup.scrollTo = () => {};

  const selects = container.querySelectorAll('select');
  selects.forEach((select) => {
    const type = select.getAttribute('data-type');

    // set initial value from URL params, if select has the value
    const urlParams = new URLSearchParams(window.location.search);
    const param = urlParams.get(type);
    if (
      param &&
      Array.from(select.options).some((o) => o.value === param)
    ) {
      select.value = param;
    }

    select.addEventListener('change', (e) => {
      if (resetSelects) {
        // reset other selects
        selects.forEach((s) => {
          if (s === select) return;
          s.classList.remove('is-active');
          s.value = '';
        });
      }

      // new url params
      const urlParams = new URLSearchParams(window.location.search);
      if (e.target.value) {
        urlParams.set(type, e.target.value);
      } else {
        urlParams.delete(type);
      }

      const url = new URL(window.location);
      url.search = urlParams.toString();

      if (e.target.value === 'infrastructure') {
        
        var grid = document.getElementById('wp-block-investments__inner');
        grid.innerHTML = '<div class="investments-item actis-link"><a href="https://www.act.is/about-us/portfolio/" target="_blank">View All Actis Investments</a></div>';
      
      } else {

        swup.navigate(url.toString(), { history: 'replace' });

      }

      select.classList.toggle('is-active', !!select.value);

    });

    const sustainableParams = new URLSearchParams(window.location.search);

    if (sustainableParams.get('type') === 'infrastructure') {
        
      var grid = document.getElementById('wp-block-investments__inner');
      grid.innerHTML = '<div class="investments-item actis-link"><a href="https://www.act.is/about-us/portfolio/" target="_blank">View All Actis Investments</a></div>';
    
    } 
  });

  const search = container.querySelector('input');
  search.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      const urlParams = new URLSearchParams(window.location.search);
      if (search.value) {
        urlParams.set('term', search.value);
      } else {
        urlParams.delete('term');
      }

      const url = new URL(window.location);
      url.search = urlParams.toString();

      swup.navigate(url.toString(), { history: 'replace' });

      search.classList.toggle('is-active', !!search.value);
    }
  });
  search.addEventListener('blur', (e) => {
    // if search is empty, remove is-active && url param
    if (!search.value) {
      search.classList.remove('is-active');
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.delete('term');
      const url = new URL(window.location);
      url.search = urlParams.toString();
      swup.navigate(url.toString(), { history: 'replace' });
    }
  });

  // pagination.
  const onClick = (e) => {
    e.preventDefault();

    const page = e.target.getAttribute('data-page');
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set('pg', page);
    const url = new URL(window.location);
    url.search = urlParams.toString();
    const key = url.toString().replace(window.location.origin, '');

    swup.preloadPromise = swup.preload(url.toString());
    swup.preloadPromise.route = url.toString();

    // append results
    swup.preloadPromise.then(() => {
      inner.querySelector('.pagination').remove();

      const div = document.createElement('div');
      div.innerHTML = swup.cache.pages.get(key).html;

      const children = div.querySelector(`${selector}__inner`).children;

      // append children to inner
      inner.append(...children);

      // new next page button
      const button = inner.querySelector('.pagination .wp-block-button__link');
      if (button) {
        button.addEventListener('click', onClick);
      }
    });

    swup.preloadPromise.finally(() => {
      swup.preloadPromise = null;
    });
  };

  swup.hooks.on('content:replace', () => {
    inner = container.querySelector(`${selector}__inner`);
    const button = inner.querySelector('.pagination .wp-block-button__link');
    if (button) {
      button.addEventListener('click', onClick);
    }
  });

  const button = container.querySelector('.pagination .wp-block-button__link');
  if (button) {
    button.addEventListener('click', onClick);
  }
};
